<template>
  <v-card>
    <v-card-title
      v-t="'activities.ofTheWeek'"
    />

    <v-skeleton-loader
      :loading="activities.loading"
      type="list-item-avatar@3"
    >
      <v-list two-line>
        <v-list-item
          v-for="activity in activities.models.slice(0, limit)"
          :key="`activity-${activity.id}`"
          :to="{ name: 'project-activities', params: { name: activity.project }, query: { a: activity.id } }"
        >
          <v-list-item-action>
            <activity-completion-toggle
              :activity="activity"
              @completed="activity.removeFromAllCollections()"
            />
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ activity.name }}</v-list-item-title>

            <v-list-item-subtitle class="d-flex mt-1">
              <pa-user-avatar
                v-if="activity.owner && !mine"
                :user-id="activity.owner"
                :size="20"
                type="avatar"
                class="mr-2"
              />

              <v-spacer />

              <span :class="activity.dueDate > today ? null : 'error--text'">
                {{ (activity.dueDate || activity.startDate) | fmtDate }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-subheader
          v-if="activities.length > limit"
          key="more-items"
          class="text-uppercase justify-center"
        >
          +{{ activities.length - limit }} {{ $tc('activities._', activities.length) }}
        </v-subheader>
      </v-list>
    </v-skeleton-loader>
  </v-card>
</template>

<script>
import moment from 'moment'

import Activities from '@/models/Activities'
import ActivityCompletionToggle from '@/components/activities/ActivityCompletionToggle'

export default {
  components: {
    ActivityCompletionToggle
  },
  props: {
    mine: {
      type: Boolean,
      required: false,
      default: false
    },
    projectId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      activities: new Activities(),
      limit: 5,
      thisWeek: moment().endOf('week').format('YYYY-MM-DD'),
      today: moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    project () {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      if (!this.projectId && !this.mine) {
        throw new Error('ActivitiesSummary: one of projectId or mine prop is required')
      }

      const query = {
        progress: { $lt: 100 },
        dueDate: { $lt: this.thisWeek, $gt: '' }
      }

      if (this.projectId) {
        query.project = this.projectId
      }

      if (this.mine) {
        query.owner = this.$currentUser.id
      }

      await this.activities.fetch(query, {
        sort: { dueDate: 1 }
      })
    }
  }
}
</script>

<style>

</style>
